import React, { useCallback, useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import PageTabs from '../Common/PageTabs';
import TradeHistoryDetails from './TradeHistory/TradeHistoryDetails';
import PnlHistoryDetails from './PnlHistory/PnlHistoryDetails';
import LedgerDetails from './Ledger/LedgerDetails';

// The slug is the URL contract (/reports/<slug>), so each tab is linkable,
// refresh-safe and reachable with the browser's back/forward buttons.
const REPORTS_TABS = [
  { label: "Trade History", value: 0, slug: 'trade-history', Component: TradeHistoryDetails },
  { label: "PnL History", value: 1, slug: 'pnl-history', Component: PnlHistoryDetails },
  { label: "Ledger", value: 2, slug: 'ledger', Component: LedgerDetails },
];

const DEFAULT_REPORTS_TAB = REPORTS_TABS[0];

const Reports = () => {
  const { tabSlug } = useParams();
  const navigate = useNavigate();

  // The URL is the single source of truth; -1 means it names no known tab.
  const matchedIndex = REPORTS_TABS.findIndex((tab) => tab.slug === tabSlug);
  const activeTab = matchedIndex === -1 ? DEFAULT_REPORTS_TAB.value : matchedIndex;

  // Bare /reports, or an unknown slug, settles on the default tab. `replace`
  // keeps the bad URL out of history so Back doesn't bounce straight into it.
  useEffect(() => {
    if (matchedIndex === -1) {
      navigate(`/reports/${DEFAULT_REPORTS_TAB.slug}`, { replace: true });
    }
  }, [matchedIndex, navigate]);

  const handleChange = useCallback((event, newValue) => {
    const next = REPORTS_TABS[newValue];
    if (next) navigate(`/reports/${next.slug}`);
  }, [navigate]);

  const ActiveComponent = REPORTS_TABS[activeTab].Component;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <PageTabs value={activeTab} onChange={handleChange} tabs={REPORTS_TABS} sticky />
      <Box
        sx={{
          flex: 1,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            pt: 0,
            px: 0,
            pb: 0,
          }}
        >
          <ActiveComponent />
        </Box>
      </Box>
    </Box>
  );
};

export default Reports;
